"use client";

import Animation4Gear from "../Animation4Gear";
import Animation3Gear from "../Animation3Gear";
import styles from "./styles.module.css";

export default function BannerBackgroundHome({section}: {section: any}) {
  return (
    <section className={styles["section-background"]}>
      <div className={styles["mesh-slide-show"]}></div>
      <Animation4Gear section={section} style={styles["background__container-adn-left"]} />
      <Animation3Gear section={section} style={styles["background__container-adn-right"]} />
    </section>
  );
}
